import type { ComponentProps, ReactNode } from "react";
import type { VariantProps } from "tailwind-variants";
import { tv } from "tailwind-variants";

const checkoutMessageVariants = tv({
  base: "mx-auto flex w-full flex-col items-start gap-x-3 gap-y-1.5 bg-white p-5",
  variants: {
    type: {
      success: "bg-green-500 text-white",
      warning: "bg-yellow-500 text-black",
      error: "bg-red-500 text-white",
    },
    hasIcon: {
      true: "flex-row",
      false: "flex-col",
    },
  },
});

type CheckoutMessageProps = ComponentProps<"div"> &
  VariantProps<typeof checkoutMessageVariants> & {
    icon?: ReactNode;
  };

export default function CheckoutMessage({
  children,
  className,
  type,
  icon,
  ...props
}: CheckoutMessageProps) {
  const hasIcon = Boolean(icon);

  return (
    <div
      className={checkoutMessageVariants({ type, hasIcon, className })}
      {...props}
    >
      <>
        {icon}
        <div className="flex flex-col gap-1">{children}</div>
      </>
    </div>
  );
}
